import { useEffect } from 'react';

import MyActiveRfisTile from 'components/CustomerHome/MyActiveRfisTile';
import RfiRepositoryTile from 'components/CustomerHome/RfiRepositoryTile';
import { useAppDispatch } from 'hooks/redux';
import { clearState } from 'store/rfiSlice';
import CategoryReport from "../components/CustomerHome/CategoryReport";
import CreateRfiTile from "../components/CustomerHome/CreateRfiTile";
import GovAppBar from "../components/GovernmentRfi/GovAppBar";
import "../styles/rfihome.css";

const Home = () => {
	const dispatch = useAppDispatch();

  useEffect(() => {	
	dispatch(clearState());
	document.body.style.paddingTop =  `0px`;
	document.title = `RFI Assistant`;
  }, []);

  //const authState = useSystemAuthState();

  return (
    <>
	 <GovAppBar />

      <main role="main" className="container-fluid mt-4">
		<div className="row">
			<div className="col-lg-5">
				<div className="tile">
				<CreateRfiTile></CreateRfiTile>
				</div>	
			</div>
			<div className="col-lg">
				<div className="tile">
				<RfiRepositoryTile></RfiRepositoryTile>
				</div>
				<div className="tile">
					<CategoryReport />
				</div>
			</div>
			<div className="col-lg">
				<div className="tile">					
					<MyActiveRfisTile></MyActiveRfisTile>
				</div>
			</div>
		</div>
	</main>
    </>
  );
};

export default Home;

